export const environment = {
  production: true,
  hmr: false,
  serverUrl: 'https://api.2040.chat/api/v1/',
  serverUrl2: 'http://localhost:8080/api/v1/',
  socketUrl: 'https://api.2040.chat/',
  socketUrl2: 'http://localhost:8080/',
  imgUrl: 'root/storage/uploads',

};
